<template>
  <div>
    <div class="mb-1"
         style="display: flex; justify-content: space-between; flex-wrap: nowrap">
      <span>
        Order by:
      </span>
      <a href="#"
         :class="{'font-weight-bold': orderBy === 0}"
         @click.prevent="changeSortOrder(0)">
        Page Number
      </a>
      <a href="#"
         :class="{'font-weight-bold': orderBy === 1}"
         @click.prevent="changeSortOrder(1)">
        Time spent
      </a>
    </div>
    <div class="analytics__pages">
      <div v-for="page in sortedPages"
           :key="page.path"
           class="mb-2"
           @click.prevent="$emit('select', page)">
        <div style="display: flex; flex-wrap: nowrap; cursor: pointer;">
          <div class="mr-2">
            <v-img :src="page.url"
                   :alt="`Page ${page.page_number}`"
                   contain
                   max-width="100">
            </v-img>
          </div>
          <div style="flex:1;"
               class="text-nowrap text-caption">
            <div style="display: flex; justify-content: space-between; flex-wrap: nowrap">
              <strong>Page {{ page.page_number }}</strong>
              <strong class="text-success">
                {{ page.time_percentage }}%
              </strong>
            </div>
            <div style="display: flex; justify-content: space-between; flex-wrap: nowrap"
                 class="text-muted text-sm">
              <div class="text-uppercase">
                Time spent:
              </div>
              <div v-if="page.total_seconds < 60 ">
                {{ formatNumber(page.total_seconds) }} sec
              </div>
              <div v-if="page.total_seconds >= 60 ">
                {{ formatNumber(page.total_minutes) }} min
              </div>
            </div>
            <div style="display: flex; justify-content: space-between"
                 class="text-muted text-sm">
              <div class="text-uppercase">
                Times viewed:
              </div>
              <div>
                {{ formatNumber(page.event_count) }}
              </div>
            </div>
          </div>
        </div>
        <v-divider></v-divider>
      </div>
    </div>
  </div>
</template>
<script>
import accounting from 'accounting';

export default {
  props: {
    pages: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      orderBy: 0,
      orderOptions: [
        {
          field: 'page_number',
          direction: 'asc',
        },
        {
          field: 'total_seconds',
          direction: 'desc',
        }
      ],
    }
  },
  computed: {
    sortedPages() {
      const option = this.orderOptions[this.orderBy];
      return _.orderBy(this.pages, [option.field], [option.direction]);
    }
  },
  methods: {
    formatNumber(num) {
      return accounting.formatNumber(num, 0);
    },
    changeSortOrder(index) {
      this.orderBy = index;
    },
  }
}
</script>
